// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscribeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_SubscribeResponse — result of POST /subscriptions/subscribe.
 *
 * Carries the checkout redirect URL and pending group details.
 * status is always 'pending' on creation — activation is webhook-only.
 *
 * PCI note: no card/cartao/cvv/pan/token field may ever be added here.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_SubscribeResponseDados {
success: boolean
subscription_id: number
status: string
pending: boolean
checkout_url: string
plan_id: number
}

export type Subscriptions_SubscribeResponse = ApiResponse<Subscriptions_SubscribeResponseDados>;

registerResponseContract('Subscriptions_SubscribeResponse', {
  success:         { type: 'boolean', required: true },
  subscription_id: { type: 'number',  required: true },
  status:          { type: 'string',  required: true },
  pending:         { type: 'boolean', required: true },
  checkout_url:    { type: 'string',  required: true },
  plan_id:         { type: 'number',  required: true },
})
